module.exports = __webpack_public_path__ + "img/img4.369f2def.svg";